import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { api } from '../redux'

import LoadingIndicator from '../components/LoadingIndicator'

import logo from '../assets/logo.svg'

const Logo = ({ isLoading }) => (
    <div className="logo">
        <Link to="/" className="navbar-brand">
            <img src={ logo } alt="Logo" />
            <LoadingIndicator size={ 25 } isVisible={ isLoading } />
        </Link>
    </div>
)

Logo.propTypes = {
    isLoading: PropTypes.bool
}


function mapStateToProps(state) {
    return {
        isLoading: api.isLoading()(state)
    }
}

export default connect(mapStateToProps)(Logo)
